// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.83.0-next',
  revision: '2fa441869',
  branch: 'next',
  date: 'Tue, 13 Jan 2026 09:47:56 GMT'
};